<!--
 * @Description: 办公用印管理 详情
 * @Author: ZSC
 * @Date: 2023-04-18 15:30:48.596
 * @LastEditors: PF
 * @LastEditTime: 2024-09-19 15:33:02
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="用印登记号" label-align="right" align="left" width="120px" span="2">{{ruleForm.yydjh}}</el-descriptions-item>
        <el-descriptions-item label="公章" label-align="right" align="left" width="120px" span="2">{{ruleForm.gzmc}}</el-descriptions-item>
        <el-descriptions-item label="用印事由" label-align="right" align="left" width="120px" span="2">{{ruleForm.yysy}}</el-descriptions-item>
        <el-descriptions-item label="事由关联号" label-align="right" align="left" width="120px" span="2">{{ruleForm.syglh}}</el-descriptions-item>
        <el-descriptions-item label="用印次数" label-align="right" align="left" width="120px" span="2">{{ruleForm.yycs}}</el-descriptions-item>
        <el-descriptions-item label="用印批准人" label-align="right" align="left" width="120px" span="2">{{ruleForm.yrpzrxm}}</el-descriptions-item>
        <el-descriptions-item label="用印批准日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.yypzrq}}</el-descriptions-item>
        <el-descriptions-item label="用印日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.yyrq}}</el-descriptions-item>
        <el-descriptions-item label="用印申请日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.yysqrq}}</el-descriptions-item>
        <el-descriptions-item label="申请人" label-align="right" align="left" width="120px" span="2">{{ruleForm.sqrxm}}</el-descriptions-item>
        <el-descriptions-item label="执行人" label-align="right" align="left" width="120px" span="2">{{ruleForm.zsrxm}}</el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.zt == 0">未提交</span>
          <span v-if="ruleForm.zt == 1">审批中</span>
          <span v-if="ruleForm.zt == 9">通过</span>
          <span v-if="ruleForm.zt == 10">拒绝</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/bangong/bangongyonyinguanli/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
